import type { Asset } from '@odo/shared-ui';
import type { PracticeDocument } from '../../../../../services/practiceDocuments';

/**
 * Maps a practice document row onto the shared files module's `Asset` shape.
 * Every practice document is DB/GCS-backed (no Monday.com source), so
 * `source` is always 'gcs' and `patientFileId` (the module's generic
 * "mutable file id" field) is always populated with the document's own id.
 * `storageCategory` carries the document type so `practiceFileCategoryConfig`
 * can group by it instead of the module's built-in extension taxonomy.
 */
export function practiceDocumentToAsset(doc: PracticeDocument): Asset {
    return {
        name: doc.originalFilename ?? 'Untitled file',
        assetId: doc.id,
        fileType: doc.documentType,
        publicUrl: '',
        source: 'gcs',
        patientFileId: doc.id,
        createdAt: doc.createdAt,
        storageCategory: doc.documentType
    };
}
